<script setup>
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();

  const props = defineProps({
    // Prefix of the header id labelling the card
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    // Field the header labels, when the card has a single one
    label_for: {
      type: String,
      required: false,
      default: ''
    },
    // Whether the criteria differs from its default value: highlighted, with a button to clear it
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    body_class: {
      type: String,
      required: false,
      default: ''
    }
  });

  const emit = defineEmits(['clear']);
</script>

<template>
  <div class="card" :class="{ 'border-primary': props.active }" role="group" :aria-labelledby="`${props.id}_title`">
    <div class="card-header d-flex align-items-center" :class="{ 'bg-primary-subtle border-primary': props.active }">
      <label v-if="props.label_for" :for="props.label_for" :id="`${props.id}_title`" class="flex-grow-1">{{ props.title }}</label>
      <span v-else :id="`${props.id}_title`" class="flex-grow-1">{{ props.title }}</span>
      <button v-if="props.active" type="button" class="btn-close ms-2" data-bs-toggle="tooltip" :data-bs-title="t('advanced_search.clear_criteria')" :aria-label="`${t('advanced_search.clear_criteria')} (${props.title})`" @click="emit('clear')"></button>
    </div>
    <div class="card-body" :class="props.body_class">
      <slot />
    </div>
  </div>
</template>
